import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProfilePage from "./pages/ProfilePage";

function App() {
  return (
    //<BrowserRouter>
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/:slug" element={<ProfilePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
